import {store} from '../../App';
import config from '../../config';

let axios   = require('axios'),
    io      = require('../io/index').actions,
    i18n    = require('i18next');

export const actiontypes = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
}

export const actions = {
  authenticateRoute: (route, level, history) => {
    let {token, user} = store.getState().session;
    let {loading}     = store.getState().io;

    if(!token) {
      return false
    } else if (!user) {
      // TODO: Rewrite this shite
      if (!loading) store.dispatch(this.actions.getUserWithToken(history, route));
      return false;
    } else {
      return user.group < level ? false : true;
    }
  },

  getUserWithToken: (history, route = null) => {
    return dispatch => {
      dispatch(io.loading());
      let messages = i18n.t('io', {returnObjects: true}).session.authenticate;
      let token = localStorage.getItem('token');

      axios.get(config.API_ADDRESS+'/user/auth/token', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(res => res.data)
      .then(json => {
        if(json.token && json.user) {
          localStorage.setItem('token', json.token);
          dispatch(loginSuccess(json));
          dispatch(io.loading(false));
          if (route) history.replace(route);
        } else {
          dispatch(io.message('Internal error', 'error', false));
        }
      })
      .catch(err =>  {
        dispatch(io.message(`${messages.error} (${err.message})`, 'error', false));
      });
    }
  },

  loginUser: (fb_token, history) => {
    return dispatch => {
      dispatch(io.loading());
      let messages = i18n.t('io', {returnObjects: true}).session.login;

      axios.get(config.API_ADDRESS+'/user/auth/facebook', {
        headers: {
          'Authorization': `Bearer ${fb_token}`
        }
      })
      .then(res => res.data)
      .then(json => {
        if(json.token && json.user) {
          localStorage.setItem('token', json.token);
          dispatch(loginSuccess(json));
          dispatch(io.loading(false));
          history.replace('/');
        } else {
          dispatch(io.message('Internal error', 'error', false));
        }
      })
      .catch(err => {
        dispatch(io.message(`${messages.error} (${err.message})`, 'error', false))
      });
    }
  },

  logoutUser: (history) => {
    return dispatch => {
      localStorage.removeItem('token');
      localStorage.removeItem('spotify_token');
      history.replace('/portal');
    }
  }
}

function loginSuccess(res) {
  return {
    type: actiontypes.LOGIN_SUCCESS,
    token: res.token,
    user: res.user,
  }
}



// WEBPACK FOOTER //
// ./src/actions/session/index.js